"use strict";

exports.__esModule = true;
exports.BM_HOOKS = void 0;
const BM_HOOKS = exports.BM_HOOKS = {
  PLAN_LIST_PLAN_CARD: 'plan-list.plan-card',
  PLAN_LIST_PLAN_CARD_LIST: 'plan-list.plan-card-list',
  PLAN_LIST_EMPTY_STATE: 'plan-list.empty-state',
  PLAN_LIST_EMPTY_STATE_HEADING: 'plan-list.empty-state.heading',
  PLAN_LIST_EMPTY_STATE_CREATE_PLAN: 'plan-list.empty-state.create-plan',
  PLAN_LIST_ARCHIVED_EMPTY_STATE: 'plan-list.archived-empty-state',
  PLAN_LIST_TABS_NAVIGATION: 'plan-list.tabs-navigation',
  PLAN_LIST_TITLE: 'plan-list.title',
  PLAN_LIST_SUBTITLE: 'plan-list.subtitle',
  PLAN_LIST_ACTIONS_MENU: 'plan-list.actions.menu',
  PLAN_LIST_ACTIONS_MENU_BUTTON: 'plan-list.actions.menu-button',
  PLAN_LIST_ACTIONS_MENU_SELL_PLAN_OFFLINE: 'plan-list.actions.menu.sell-plan-offline',
  PLAN_LIST_ACTIONS_MENU_PURCHASED_PLANS: 'plan-list.actions.menu.purchased-plans',
  PLAN_LIST_ACTIONS_MENU_VIEW_REPORTS: 'plan-list.actions.menu.view-reports',
  PLAN_LIST_ACTIONS_MENU_VIEW_SUBSCRIPTION_ANALYTICS: 'plan-list.actions.menu.view-subscription-analytics',
  PLAN_LIST_ACTIONS_MENU_MANAGE_SETTINGS: 'plan-list.actions.menu.manage-settings',
  PLAN_LIST_ACTIONS_MENU_PERMISSIONS_TOOLTIP: 'plan-list.actions.menu-permissions-tooltip',
  PLAN_LIST_ACTIONS_CREATE_PLAN: 'plan-list.actions.create-plan',
  PLAN_LIST_ACTIONS_MANAGE_SETTINGS: 'plan-list.actions.manage-settings',
  PLAN_LIST_ACTIONS_AI_ASSISTANT: 'plan-list.actions.ai-assistant',
  PLAN_LIST_ACTIONS_CREATE_COUPON: 'plan-list.actions.create-coupon',
  PLAN_LIST_PAGE: 'plan-list.page',
  PLAN_LIST_ARCHIVE_MODAL: 'plan-list.archive-modal',
  PLAN_LIST_VISIBILITY_MODAL: 'plan-list.visibility-modal',
  PLAN_LIST_EDIT_BENEFITS_MODAL: 'plan-list.edit-benefits-modal',
  PLAN_LIST_EDIT_BENEFITS_MODAL_WARNING: 'plan-list.edit-benefits-modal.warning',
  PLAN_LIST_EDIT_BENEFITS_MODAL_ERROR: 'plan-list.edit-benefits-modal.error',
  PLAN_CARD_NAME: 'plan-card.name',
  PLAN_CARD_TYPE: 'plan-card.type',
  PLAN_CARD_PRICE: 'plan-card.price',
  PLAN_CARD_ACTIONS: 'plan-card.actions',
  PLAN_CARD_ACTIONS_MENU: 'plan-card.actions.menu',
  PLAN_CARD_ACTIONS_MENU_BUTTON: 'plan-card.actions.menu-button',
  PLAN_CARD_ACTIONS_MENU_HIDE: 'plan-card.actions.menu.hide',
  PLAN_CARD_ACTIONS_MENU_UNHIDE: 'plan-card.actions.menu.unhide',
  PLAN_CARD_ACTIONS_MENU_ARCHIVE: 'plan-card.actions.menu.archive',
  PLAN_CARD_ACTIONS_CREATE_COUPON: 'plan-card.actions.menu.create-coupon',
  PLAN_CARD_ACTIONS_EDIT: 'plan-card.actions.edit',
  PLAN_CARD_ACTIONS_VIEW: 'plan-card.actions.view',
  PLAN_CARD_ACTIONS_EDIT_BENEFITS: 'plan-card.actions.edit-benefits',
  PLAN_CARD_ICON_HIDDEN: 'plan-card.icon.hidden',
  PLAN_CARD_VALIDITY: 'plan-card.validity',
  NEW_PLAN_PAGE: 'new-plan.page',
  PLAN_SETUP_TITLE: 'plan-setup.title',
  PLAN_SETUP_BREADCRUMBS: 'plan-setup.breadcrumbs',
  PLAN_SETUP_ACTIONS_SUBMIT: 'plan-setup.actions.submit',
  PLAN_SETUP_ACTIONS_SUBMIT_LOADER: 'plan-setup.actions.submit-loader',
  PLAN_SETUP_ACTIONS_CANCEL: 'plan-setup.actions.cancel',
  PLAN_SETUP_CANCEL_MODAL: 'plan-setup.cancel-modal',
  PLAN_SETUP_LEAVE_MODAL: 'plan-setup.leave-modal',
  PLAN_SETUP_WRAPPER_COMPONENT: 'plan-setup.wrapper-component',
  PLAN_SETUP_CUSTOM_PAYMENT_FREQUENCY_DISCLAIMER: 'plan-setup.custom-payment-frequency-disclaimer',
  PLAN_SETUP_CUSTOM_PAYMENT_FREQUENCY_DISCLAIMER_SETUP_FEE: 'plan-setup.custom-payment-frequency-disclaimer.setup-fee',
  FORM_CONTAINER: 'form.container',
  FORM_SECTION_TITLE: 'form.section.title',
  FORM_SECTION_SUBTITLE: 'form.section.subtitle',
  FORM_SECTION_SUFFIX: 'form.section.suffix',
  FORM_INFO_SECTION: 'form.info',
  FORM_INFO_SECTION_HEADER: 'form.info.header',
  FORM_INFO_SECTION_SUBTITLE: 'form.info.subtitle',
  FORM_PERKS_HEADER: 'form.perks.header',
  FORM_PERKS_HEADER_TEXT: 'form.perks.header-text',
  FORM_PERKS_CONTENT: 'form.perks.content',
  FORM_TITLE_FIELD: 'form.title-field',
  FORM_TITLE_INPUT: 'form.title-input',
  FORM_TAGLINE_FIELD: 'form.tagline-field',
  FORM_TAGLINE_INPUT: 'form.tagline-input',
  FORM_BENEFITS_INPUT: 'form.benefits-input',
  FORM_IMAGE_BUTTON: 'form.image-button',
  FORM_IMAGE_FIELD: 'form.image-field',
  FORM_PLAN_PREVIEW: 'form.plan-preview',
  FORM_PRICING_OPTIONS: 'form.pricing-options',
  FORM_PRICING_OPTIONS_HEADER: 'form.pricing-options.header',
  FORM_ADVANCED_SETTINGS: 'form.advanced-settings',
  FORM_ADVANCED_SETTINGS_HEADER: 'form.advanced-settings.header',
  FORM_ADVANCED_SETTINGS_HEADER_TITLE: 'form.advanced-settings.header-title',
  FORM_ADVANCED_SETTINGS_HEADER_SUBTITLE: 'form.advanced-settings.header-subtitle',
  FORM_ADVANCED_SETTINGS_SINGLE_PURCHASE: 'form.advanced-settings.single-purchase',
  FORM_ADVANCED_SETTINGS_PURCHASE_ONCE_INPUT: 'form.advanced-settings.purchase-once-input',
  FORM_ADVANCED_SETTINGS_ALLOW_CANCELLATION: 'form.advanced-settings.allow-cancellation',
  FORM_ADVANCED_SETTINGS_ALLOW_CANCELLATION_INPUT: 'form.advanced-settings.allow-cancellation-input',
  FORM_ADVANCED_SETTINGS_DISABLE_PLAN_CANCELLATION_MODAL: 'form.advanced-settings.disable-plan-cancellation-modal',
  FORM_ADVANCED_SETTINGS_CUSTOM_START_DATE: 'form.advanced-settings.custom-start-date',
  FORM_ADVANCED_SETTINGS_CUSTOM_START_DATE_INPUT: 'form.advanced-settings.custom-start-date-input',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS: 'form.advanced-settings.terms-and-conditions',
  FORM_ADVANCED_SETTINGS_EDIT_TERMS_AND_CONDITIONS: 'form.advanced-settings.edit-terms-and-conditions',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL: 'form.advanced-settings.terms-and-conditions-modal',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_FOOTER: 'form.advanced-settings.terms-and-conditions-modal.footer',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_CHECKBOX_SETTINGS_LABEL: 'form.advanced-settings.terms-and-conditions-modal.checkbox-settings-label',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_SHOW_CHECKBOX_TOGGLE: 'form.advanced-settings.terms-and-conditions-modal.show-checkbox-toggle',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_SHOW_CHECKBOX_TOGGLE_LABEL: 'form.advanced-settings.terms-and-conditions-modal.show-checkbox-toggle-label',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_CHECKED_BY_DEFAULT_TOGGLE: 'form.advanced-settings.terms-and-conditions-modal.checked-by-default-toggle',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_CHECKED_BY_DEFAULT_TOGGLE_LABEL: 'form.advanced-settings.terms-and-conditions-modal.checked-by-default-toggle-label',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW: 'form.advanced-settings.terms-and-conditions-modal.preview',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW_TERMS_AND_CONDITIONS: 'form.advanced-settings.terms-and-conditions-modal.preview.terms-and-conditions',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW_CHECKBOX_LABEL: 'form.advanced-settings.terms-and-conditions-modal.preview.checkbox-label',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW_EMPTY_CHECKBOX: 'form.advanced-settings.terms-and-conditions-modal.preview.empty-checkbox',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW_CHECKED_CHECKBOX: 'form.advanced-settings.terms-and-conditions-modal.preview.checked-checkbox',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_MODAL_PREVIEW_BUTTON: 'form.advanced-settings.terms-and-conditions-modal.preview.button',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_INPUT: 'form.advanced-settings.terms-and-conditions-input',
  FORM_ADVANCED_SETTINGS_TERMS_AND_CONDITIONS_FIELD: 'form.advanced-settings.terms-and-conditions-field',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE: 'form.advanced-settings.thank-you-page',
  FORM_ADVANCED_SETTINGS_EDIT_THANK_YOU_PAGE: 'form.advanced-settings.edit-thank-you-page',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL: 'form.advanced-settings.thank-you-page-modal',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_TITLE_INPUT: 'form.advanced-settings.thank-you-page-modal.title-input',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_TITLE_FIELD: 'form.advanced-settings.thank-you-page-modal.title-field',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_BUTTON_LABEL_INPUT: 'form.advanced-settings.thank-you-page-modal.button-label-input',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_BUTTON_LABEL_FIELD: 'form.advanced-settings.thank-you-page-modal.button-label-field',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_URL_INPUT: 'form.advanced-settings.thank-you-page-modal.url-input',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_URL_FIELD: 'form.advanced-settings.thank-you-page-modal.url-field',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_URL_DROPDOWN: 'form.advanced-settings.thank-you-page-modal.url-dropdown',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_URL_DROPDOWN_FIELD: 'form.advanced-settings.thank-you-page-modal.url-dropdown-field',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_LINK_TYPE: 'form.advanced-settings.thank-you-page-modal.link-type',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_PREVIEW_TITLE: 'form.advanced-settings.thank-you-page-modal.preview.title',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_PREVIEW_BUTTON: 'form.advanced-settings.thank-you-page-modal.preview.button',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_RESET: 'form.advanced-settings.thank-you-page-modal.reset',
  FORM_ADVANCED_SETTINGS_THANK_YOU_PAGE_MODAL_EDITOR: 'form.advanced-settings.thank-you-page-modal.editor',
  PRICING_OPTIONS_PRICE_INPUT: 'pricing-options.price-input',
  PRICING_OPTIONS_PRICE_FIELD: 'pricing-options.price-field',
  PRICING_OPTIONS_DURATION_INPUT: 'pricing-options.duration-input',
  PRICING_OPTIONS_DURATION_FIELD: 'pricing-options.duration-field',
  PRICING_OPTIONS_CUSTOM_DURATION_FREQUENCY_INPUT: 'pricing-options.custom-duration-frequency-input',
  PRICING_OPTIONS_CUSTOM_DURATION_FREQUENCY_FIELD: 'pricing-options.custom-duration-frequency-field',
  PRICING_OPTIONS_CUSTOM_DURATION_INPUT: 'pricing-options.custom-duration-input',
  PRICING_OPTIONS_CUSTOM_DURATION_FIELD: 'pricing-options.custom-duration-field',
  PRICING_OPTIONS_FREE_TRIAL_INPUT: 'pricing-options.free-trial-input',
  PRICING_OPTIONS_FREE_TRIAL_FIELD: 'pricing-options.free-trial-field',
  PRICING_OPTIONS_FREE_TRIAL_DAYS_INPUT: 'pricing-options.free-trial-days-input',
  PRICING_OPTIONS_FREE_TRIAL_DAYS_FIELD: 'pricing-options.free-trial-days-field',
  PRICING_OPTIONS_RECURRING_PREMIUM_HELPER: 'pricing-options.recurring-premium-helper',
  PRICING_OPTIONS_PAYMENT_FREQUENCY_INPUT: 'pricing-options.payment-frequency-input',
  PRICING_OPTIONS_PAYMENT_FREQUENCY_FIELD: 'pricing-options.payment-frequency-field',
  PRICING_OPTIONS_CUSTOM_PAYMENT_FREQUENCY_UNIT_INPUT: 'pricing-options.custom-payment-frequency-unit-input',
  PRICING_OPTIONS_CUSTOM_PAYMENT_FREQUENCY_COUNT_FIELD: 'pricing-options.custom-payment-frequency-count-field',
  PRICING_OPTIONS_CUSTOM_PAYMENT_FREQUENCY_COUNT_INPUT: 'pricing-options.custom-payment-frequency-count-input',
  PRICING_OPTIONS_SETUP_FEE_INPUT: 'pricing-options.setup-fee-input',
  PRICING_OPTIONS_SETUP_FEE_FIELD: 'pricing-options.setup-fee-field',
  PRICING_OPTIONS_SETUP_FEE_AMOUNT_INPUT: 'pricing-options.setup-fee-amount-input',
  PRICING_OPTIONS_SETUP_FEE_AMOUNT_FIELD: 'pricing-options.setup-fee-amount-field',
  PRICING_OPTIONS_SETUP_FEE_NAME_INPUT: 'pricing-options.setup-fee-name-input',
  PRICING_OPTIONS_SETUP_FEE_NAME_FIELD: 'pricing-options.setup-fee-name-field',
  PRICING_OPTIONS_SETUP_FEE_TOOLTIP_LINK: 'pricing-options.setup-fee-tooltip-link',
  CONTACTS_MODAL_LAYOUT: 'contacts-modal-layout',
  CONTACTS_MODAL_LIST: 'contacts-modal-list',
  CONTACTS_DUPLICATE_EMAIL_MODAL: 'contacts-duplicate-email-modal',
  MOCK_EDIT_CONTACT_COMPONENT: 'mock-edit-contact-component',
  CONTACTS_MODAL_ADD_NEW_BUTTON: 'contacts-modal-add-new-button',
  NEW_ORDER_CONTACT: 'new-order-contact',
  NEW_ORDER_CONTACT_ERROR: 'new-order-contact-error',
  NEW_ORDER_CONTACT_AVATAR: 'new-order-contact-avatar',
  NEW_ORDER_CONTACT_NAME: 'new-order-contact-name',
  NEW_ORDER_CONTACT_EMAIL: 'new-order-contact-email',
  NEW_ORDER_CONTACT_PHONE: 'new-order-contact-phone',
  NEW_ORDER_PAGE: 'new-order.page',
  NEW_ORDER_ACTIONS_COMPLETE_PURCHASE: 'new-order.actions.complete-purchase',
  NEW_ORDER_ACTIONS_CANCEL: 'new-order.actions.cancel',
  NEW_ORDER_FORM: 'new-order.order-form',
  NEW_ORDER_FORM_PLAN_DROPDOWN: 'new-order.order-form.plan-dropdown',
  NEW_ORDER_FORM_PAYMENT_STATUS_DROPDOWN: 'new-order.order-form.payment-status-dropdown',
  NEW_ORDER_FORM_START_DATE_DATE_PICKER: 'new-order.order-form.start-date-date-picker',
  NEW_ORDER_FORM_PLAN_INFO_FREE_TRIAL_DAYS: 'new-order.order-form.plan-info.free-trial-days',
  NEW_ORDER_FORM_PLAN_INFO_PURCHASE_LIMIT_EXCEEDED: 'new-order.order-form.plan-info.purchase-limit-exceeded',
  NEW_ORDER_OVERVIEW: 'new-order.order-overview',
  NEW_ORDER_OVERVIEW_PLAN_PURCHASED: 'new-order.order-overview.plan-purchased',
  NEW_ORDER_OVERVIEW_START_DATE: 'new-order.order-overview.start-date',
  NEW_ORDER_OVERVIEW_VALID_UNTIL: 'new-order.order-overview.valid-until',
  NEW_ORDER_OVERVIEW_PRICE: 'new-order.order-overview.price',
  NEW_ORDER_OVERVIEW_PAYMENT_STATUS: 'new-order.order-overview.payment-status',
  NEW_ORDER_OVERVIEW_PAYMENT_METHOD: 'new-order.order-overview.payment-method',
  NEW_ORDER_OVERVIEW_FREE_TRIAL: 'new-order.order-overview.free-trial',
  NEW_ORDER_OVERVIEW_SETUP_FEE: 'new-order.order-overview.setup-fee',
  NEW_ORDER_MODAL: 'new-order.modal',
  NEW_ORDER_MODAL_PLAN_HOLDER: 'new-order.modal.plan-holder',
  NEW_ORDER_MODAL_PLAN_NAME: 'new-order.modal.plan-name',
  NEW_ORDER_MODAL_PAYMENT: 'new-order.modal.payment',
  NEW_ORDER_MODAL_PAYMENT_STATUS: 'new-order.modal.payment-status',
  NEW_ORDER_HEADER: 'new-order.header.back-button',
  NEW_ORDER_BREADCRUMBS: 'new-order.breadcrumbs',
  PLAN_SETUP_MODAL_LAYOUT: 'plan-setup-modal-layout',
  PLAN_SETUP_MODAL_LOADER: 'plan-setup-modal-loader',
  PLAN_SETUP_WRAPPER: 'plan-setup-wrapper',
  PLAN_SETUP_WRAPPER_SUBMIT: 'plan-setup-wrapper-submit',
  PLAN_SETUP_WRAPPER_CANCEL: 'plan-setup-wrapper-cancel',
  PLAN_SETUP_MODAL_WRAPPER: 'plan-setup-modal-wrapper',
  PLAN_SETUP_INTEGRATIONS_WRAPPPER: 'plan-setup-integrations-wrapper',
  PLAN_SETUP_INTEGRATION: 'plan-setup-integration',
  PLAN_SETUP_INTEGRATIONS_EDIT_WARNING: 'plan-setup-integration-editing-warning',
  PLAN_LIST_WIDGET_LOADER: 'plan-list.widget-loader',
  PRE_MODAL: 'pre-modal',
  CONNECTED_PLANS_POPOVER: 'connected-plan-popover',
  CONNECTED_PLANS_POPOVER_TITLE: 'connected-plan-popover-title',
  CONNECTED_PLANS_EXAMPLE_BUTTON: 'connected-plan-popover-example-button',
  CONNECT_MODAL: 'connect-modal',
  CONNECT_MODAL_PLAN: 'connect-modal.plan',
  CONNECT_MODAL_PLAN_NAME: 'connect-modal.plan-name',
  CONNECT_MODAL_PLAN_HIDDEN_ICON: 'connect-modal.plan-hidden-icon',
  CONNECT_MODAL_PLAN_PRICING_DETAILS: 'connect-modal.plan.pricing-details',
  CONNECT_MODAL_CREATE_PLAN: 'connect-modal.create-plan',
  CONNECT_MODAL_ACTIONS_CONNECT: 'connect-modal.actions.connect',
  CONNECT_MODAL_ACTIONS_MENU: 'connect-modal.actions.menu',
  CONNECT_MODAL_ACTIONS_MENU_BUTTON: 'connect-modal.actions.menu-button',
  CONNECT_MODAL_ACTIONS_MENU_EDIT: 'connect-modal.actions.menu.edit',
  CONNECT_MODAL_ACTIONS_MENU_HIDE: 'connect-modal.actions.menu.hide',
  CONNECT_MODAL_ACTIONS_MENU_UNHIDE: 'connect-modal.actions.menu.unhide',
  CONNECT_MODAL_ACTIONS_DISCONNECT_MENU: 'connect-modal.actions.disconnect-menu',
  CONNECT_MODAL_ACTIONS_DISCONNECT_MENU_BUTTON: 'connect-modal.actions.disconnect-menu-button',
  CONNECT_MODAL_ACTIONS_DISCONNECT_MENU_DISCONNECT: 'connect-modal.actions.disconnect-menu.disconnect',
  CONNECT_MODAL_SECTION_HELPER_SUCCESS: 'conncet-modal.section-helper.success',
  CONNECT_MODAL_SECTION_HELPER_HIDDEN: 'conncet-modal.section-helper.hidden',
  DISCONNECT_MODAL: 'disconnect-modal',
  DISCONNECT_MODAL_CONTENT: 'disconnect-modal.content',
  CONNECT_CONFIRMATION_MODAL: 'connect-confirmation-modal',
  CONNECT_CONFIRMATION_MODAL_CONTENT: 'connect-confirmation-modal-content',
  FLOATING_NOTIFICATION: 'floating-notification',
  SETTINGS_PAGE: 'settings-page',
  SETTINGS_PAGE_BREADCRUMBS: 'settings-page.breadcrumbs',
  SETTINGS_BILLING_CONTAINER: 'settings-billing',
  SETTINGS_BILLING_LOADER: 'settings-billing-loader',
  SETTINGS_TAX_CONTAINER: 'settings-tax',
  SETTINGS_TAX_HEADER: 'settings-tax.header',
  SETTINGS_TAX_SAVE_BUTTON: 'settings-tax.save-button',
  SETTINGS_TAX_CANCEL_BUTTON: 'settings-tax.cancel-button',
  SETTINGS_TAX_LOADER: 'settings-tax.loader',
  SETTINGS_TAX_BREADCRUMBS: 'setttings-tax.breadcrumbs',
  SETTINGS_AUTOMATIONS_CONTAINER: 'settings-automations',
  SETTINGS_AUTOMATIONS_USER_AUTOMATIONS_SUBTITLE_BUTTON: 'settings-automations.user-automations.subtitle-button',
  SETTINGS_AUTOMATIONS_SERVICE_AUTOMATIONS_SUBTITLE_BUTTON: 'settings-automations.service-automations.subtitle-button',
  SETTINGS_CHECKOUT_CONTAINER: 'settings-checkout',
  SETTINGS_CHECKOUT_LOADER: 'settings-checkout-loader',
  SETTINGS_TABS: 'settings.tabs',
  SETTINGS_AUTOMATIONS_TAB_BUTTON: 'settings.tabs-button.automations',
  SETTINGS_CHECKOUT_TAB_BUTTON: 'settings.tabs-button.checkout',
  SETTINGS_BILLING_TAB_BUTTON: 'settings.tabs-button.billing',
  DISCARD_CHANGES_MODAL: 'discard-changes-modal',
  TAX_CONFIG_ENTRY_CARD_CTA: 'tax-entry-config-card.cta',
  TAX_CONFIG_ENTRY_CARD_TOGGLE: 'tax-entry-config-card.toggle',
  TAX_CONFIG_ENTRY_CARD_OVERVIEW: 'tax-entry-config-card.overview',
  TAX_CONFIG_CARD_HEADER: 'tax-config-card.header',
  TAX_CONFIG_CARD_TAX_RATE_INPUT: 'tax-config-card.tax-rate-input',
  TAX_CONFIG_CARD_TAX_INCLUDED: 'tax-config-card.tax-included',
  TAX_CONFIG_CARD_TAX_ADDED: 'tax-config-card.tax-added',
  SETTINGS_AUTOMATIONS_EDIT_BUTTON: 'main-action-button',
  AUTOMATIONS_NOTIFICATIONS_BACK_BUTTON: 'notification-cta-button',
  NEAR_PLAN_LIMIT_WARNING: 'near-plan-limit-warning',
  REACHED_PLAN_LIMIT_WARNING: 'reached-plan-limit-warning',
  PLAN_LIMIT_REACHED_MODAL: 'plan-limit-reached-modal',
  NEW_ORDER_FORM_START_DATE_IN_THE_PAST: 'new-order-form-start-date-in-the-past',
  NEW_ORDER_ACTIONS_COLLECT_PAYMENT: 'new-order.actions.collect-payment',
  NEW_ORDER_ACTIONS_COLLECT_PAYMENT_BY_CREDIT_CARD: 'new-order.actions.collect-payment.credit-card',
  NEW_ORDER_ACTIONS_COLLECT_PAYMENT_BY_MARK_AS_PAID: 'new-order.actions.collect-payment.mark-as-paid',
  NEW_ORDER_ACTIONS_COLLECT_PAYMENT_BY_MARK_AS_UNPAID: 'new-order.actions.collect-payment.mark-as-unpaid',
  PLAN_TYPE_MODAL: 'plan-type-modal',
  PLAN_TYPE_MODAL_CELL: 'plan-type-modal.cell',
  PLAN_TYPE_THUMBNAIL: 'plan-type-thumbnail',
  PLAN_TYPE_THUMBNAIL_TITLE: 'plan-type-thumbnail.title',
  DEALER_BANNER: 'dealer-banner',
  DEALER_BANNER_LAYOUT: 'dealer-banner-layout',
  DEALER_BANNER_IMAGE: 'dealer-banner-image',
  DEALER_BANNER_SUBTITLE_LINK: 'dealer-banner-subtitle-link',
  DEALER_BANNER_CLOSE_BUTTON: 'dealer-banner-close-button',
  DEALER_BANNER_CTA_BUTTON: 'dealer-banner-cta-button',
  DEALER_CAROUSEL: 'dealer-carousel',
  DEALER_CAROUSEL_LAYOUT: 'dealer-carousel-layout',
  MANAGE_PLANS_MODAL_LAYOUT: 'manage-plans-modal.layout',
  MANAGE_PLANS_MODAL_PLANS: 'manage-plans-modal.plans',
  MANAGE_PLANS_MODAL_PLAN_NAME: 'manage-plans-modal.plan-name',
  MANAGE_PLANS_MODAL_PLAN_TYPE: 'manage-plans-modal.plan-type',
  MANAGE_PLANS_MODAL_PLAN_PRICE: 'manage-plans-modal.plan-price',
  MANAGE_PLANS_MODAL_PLAN_LOADER: 'manage-plans-modal.plan-loader',
  MANAGE_PLANS_MODAL_CONNECT_SWITCH: 'manage-plans-modal.connect-switch',
  MANAGE_PLANS_MODAL_CONNECT_LABEL: 'manage-plans-modal.connect-label',
  MANAGE_PLANS_MODAL_HIDDEN_TOOLTIP: 'manage-plans-modal.hidden-tooltip',
  MANAGE_PLANS_MODAL_CREATE_PLAN: 'manage-plans-modal.create-plan',
  MANAGE_PLANS_MODAL_EDIT: 'manage-plans-modal.edit',
  MANAGE_PLANS_MODAL_PLAN: 'manage-plans-modal.plan',
  SETTINGS_INVOICES_TOGGLE: 'settings-invoices-toggle',
  SETTINGS_INVOICES_EDIT_BUTTON: 'settings-invoices-edit-button',
  SETTINGS_INVOICES_CREATE_BUTTON: 'settings-invoices-create-button',
  SETTINGS_GUEST_CHECKOUT_CARD: 'settings-guest-checkout-card',
  SETTINGS_GUEST_CHECKOUT_TOGGLE: 'settings-guest-checkout-toggle',
  SETTINGS_GUEST_CHECKOUT_NOTIFICATION: 'settings-guest-checkout-notification',
  SETTINGS_PAYMENTS_CARD_NO_PAYMENT_METHOD_HELPER: 'payments.no-payment-mothod-helper',
  SETTINGS_PAYMENTS_CARD_NO_RECURRING_PAYMENT_METHOD_HELPER: 'payments.no-recurring-payment-mothod-helper',
  SETTINGS_PAYMENTS_CARD_NO_PREMIUM_HELPER: 'paymetns.no-recurring-payment-mothod-helper',
  SETTINGS_PAYMENTS_CARD_BUTTON: 'settings-payments-card-button',
  MULTIMODULE_PLAN_TYPE_MODAL: 'multimodule-plan-type-modal',
  MULTIMODULE_PLAN_TYPE_MODAL_OPTIONS: 'multimodule-plan-type-modal.options',
  FORM_ADVANCED_SETTINGS_CUSTOM_FIELDS: 'form.advanced-settings.custom-fields',
  FORM_ADVANCED_SETTINGS_EDIT_CUSTOM_FIELDS: 'form.advanced-settings.edit-custom-fields',
  CUSTOM_FORMS_TABLE_CARD: 'custom-forms-config-card',
  CUSTOM_FORMS_TABLE_CARD_HEADER: 'custom-forms-config-card.header',
  CUSTOM_FORMS_TABLE_CARD_HEADER_CREATE_FORM: 'custom-forms-config-card.header.create-form',
  CUSTOM_FORMS_TABLE_CARD_LIST_ITEM_POPOVER: 'custom-forms-config-card.list-item.popover',
  CUSTOM_FORMS_TABLE_CARD_LIST_ITEM_CONNECTED_PLANS: 'custom-forms-config-card.list-item.connected-plans',
  CUSTOM_FORMS_TABLE_CARD_LIST_ITEM_ACTION: 'custom-forms-config-card.list-item.action',
  CUSTOM_FORMS_TABLE_CARD_LIST_ITEM_ASSIGN_PLAN: 'custom-forms-config-card.list-item.assign-plan',
  CUSTOM_FORMS_TABLE_CARD_ERROR_EMPTY_STATE: 'custom-forms-config-card.error-empty-state',
  CUSTOM_FORMS_TABLE_CARD_ERROR_EMPTY_STATE_ACTION: 'custom-forms-config-card.error-empty-state.action',
  CUSTOM_FORMS_TABLE_CARD_NO_FORMS_EMPTY_STATE: 'custom-forms-config-card.no-forms-empty-state',
  CUSTOM_FORMS_TABLE_CARD_NO_FORMS_EMPTY_STATE_ACTION: 'custom-forms-config-card.no-forms-empty-state.action',
  CUSTOM_CHECKOUT_FIELDS_MODAL: 'custom-checkout-fields-modal',
  CUSTOM_CHECKOUT_FIELDS_MODAL_CREATE: 'custom-checkout-fields-modal.create',
  CUSTOM_CHECKOUT_FIELDS_MODAL_EDIT: 'custom-checkout-fields-modal.edit',
  CUSTOM_CHECKOUT_FIELDS_MODAL_OPTIONS: 'custom-checkout-fields-modal.options',
  CUSTOM_CHECKOUT_FIELDS_MODAL_OPTION: 'custom-checkout-fields-modal.option',
  CUSTOM_CHECKOUT_FIELDS_MODAL_OPTION_NONE: 'custom-checkout-fields-modal.option.none',
  CUSTOM_CHECKOUT_FIELDS_MODAL_EMPTY_STATE: 'custom-checkout-fields-modal.empty-state',
  CUSTOM_CHECKOUT_FIELDS_MODAL_EMPTY_STATE_TEXT: 'custom-checkout-fields-modal.empty-state.text',
  DELETE_CUSTOM_FORM_MODAL: 'delete-custom-form-modal',
  DELETE_CUSTOM_FORM_MODAL_TEXT: 'delete-custom-form-modal.text',
  COVER_IMAGE_MODAL: 'cover-image-modal.modal',
  COVER_IMAGE_MODAL_DONT_SHOW_AGAIN_CHECKBOX: 'cover-image-modal.modal.dont-show-again-checkbox',
  WELCOME_PAGE: 'welcome-page',
  WELCOME_PAGE_CONTENT: 'welcome-page.content',
  WELCOME_PAGE_LOADER: 'welcome-page.loader',
  WELCOME_PAGE_LEARN_MORE: 'welcome-page.learn-more',
  WELCOME_PAGE_GET_STARTED: 'welcome-page.get-started',
  ONBOARDING_COMPLETE_BANNER: 'onboarding-complete-banner',
  ONBOARDING_COMPLETE_BANNER_SETTINGS: 'onboarding-complete-bannner.settings',
  ONBOARDING_COMPLETE_BANNER_CLOSE_BUTTON: 'onboarding-complete-banner.close-button',
  ONBOARDING_CHECKLIST_HEADER: 'onboarding-checklist.header',
  ONBOARDING_CHECKLIST_COLLAPSE_BUTTON: 'onboarding-checklist.collapse-button',
  ONBOARDING_CHECKLIST_COLLAPSE: 'onboarding-checklist.collapse',
  ONBOARDING_CHECKLIST_CREATE_PLAN_BUTTON: 'onboarding-checklist.create-plan-button',
  ONBOARDING_CHECKLIST_CREATE_PLAN_WITH_AI_BUTTON: 'onboarding-checklist.create-plan-with-ai-button',
  ONBOARDING_CHECKLIST_CONNECT_PAYMENT_METHODS_BUTTON: 'onboarding-checklist.connect-payment-methods-button',
  ONBOARDING_CHECKLIST_UPGRADE_TO_PREMIUM_BUTTON: 'onboarding-checklist.upgrade-to-premium-button',
  GALLERY: 'gallery',
  GALLERY_SECTIONS: 'gallery.sections',
  GALLERY_PACKAGES_SECTION: 'gallery.sections.packages',
  GALLERY_MEMBERSHIPS_SECTION: 'gallery.sections.memerbships',
  GALLERY_TEMPLATE_CARD: 'gallery.card',
  GALLERY_TEMPLATE_CARD_TITLE: 'gallery.card.title',
  GALLERY_TEMPLATE_CARD_DESCRIPTION: 'gallery.card.description',
  GALLERY_TEMPLATE_EDIT: 'gallery.card.edit',
  GALLERY_START_FROM_SCRATCH: 'gallery.start-from-scratch',
  GALLERY_LOADER: 'gallery.loader',
  MOTO_MODAL: 'moto-modal',
  MOTO_CONNECT_PAYMENT_METHOD_MODAL: 'moto.connect-payment-method-modal',
  MOTO_CONNECT_PAYMENT_METHOD_MODAL_LEARN_MORE: 'moto.connect-payment-method-modal.learn-more',
  SUBSCRIPTION_WIDGET_BOOKINGS: 'subscription-widget-bookings',
  SUBSCRIPTION_DETAILS_PAGE: 'details-page',
  PLAN_LIST_CAIRO_TABLE: 'plan-list.cairo-table',
  PLAN_LIST_CAIRO_TABLE_BULK_SHOW: 'plan-list.cairo-table.bulk-show',
  PLAN_LIST_CAIRO_TABLE_BULK_HIDE: 'plan-list.cairo-table.bulk-hide',
  PLAN_LIST_CAIRO_TABLE_BULK_ARCHIVE: 'plan-list.cairo-table.bulk-archive',
  PLAN_LIST_CAIRO_TABLE_HIDE: 'plan-list.cairo-table.hide',
  PLAN_LIST_CAIRO_TABLE_SHOW: 'plan-list.cairo-table.show',
  PLAN_LIST_CAIRO_TABLE_ARCHIVE: 'plan-list.cairo-table.archive',
  PLAN_LIST_CAIRO_TABLE_EDIT_BENEFITS: 'plan-list.cairo-table.edit-benefits',
  PLAN_LIST_CAIRO_TABLE_CREATE_COUPON: 'plan-list.cairo-table.create-coupon',
  DASHBOARD_ANALYTICS_WIDGET: 'dashboard-header.analytics-widget',
  INTEGRATION_LIST_EMPTY_STATE: 'integration-list.empty-state',
  TAX_BREAKDOWN_TAX_NAME: 'tax-breakdown.tax-name',
  TAX_BREAKDOWN_PRICE: 'tax-breakdown.price',
  BENEFIT_PROGRAMS_SECTION: 'benefit-programs-section',
  BENEFIT_PROGRAMS_SECTION_HEADER: 'benefit-programs-section.header',
  BENEFIT_PROGRAMS_SECTION_ACCORDION: 'benefit-programs-section.accordion',
  BENEFIT_PROGRAMS_SECTION_PICKER: 'benefit-programs-section.picker',
  BENEFIT_PROGRAMS_SECTION_BASIC: 'benefit-programs-section.basic',
  BENEFIT_PROGRAMS_SECTION_BASIC_ROW: 'benefit-programs-section.basic.row',
  BENEFIT_PROGRAMS_SECTION_BASIC_ADD_ROW: 'benefit-programs-section.basic.add-row',
  BENEFIT_PROGRAMS_SECTION_BASIC_DELETE_ROW: 'benefit-programs-section.basic.delete-row',
  BENEFIT_PROGRAMS_SECTION_BASIC_CREDIT: 'benefit-programs-section.basic.credit',
  BENEFIT_PROGRAMS_SECTION_ADVANCED: 'benefit-programs-section.advanced',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_ROW: 'benefit-programs-section.advanced.row',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_ADD_ROW: 'benefit-programs-section.advanced.add-row',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_REMOVE_ROW: 'benefit-programs-section.advanced.remove-row',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDIT: 'benefit-programs-section.advanced.credit',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_EDIT_TIME: 'benefit-programs-section.advanced.edit-time',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_MODE_SELECTOR: 'benefit-programs-section.advanced.mode',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDITS_MODE_INPUT: 'benefit-programs-section.advanced.credits',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_SESSIONS_MODE_INPUT: 'benefit-programs-section.advanced.sessions',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_SESSION_LIMIT: 'benefit-programs-section.advanced.sessions.limit',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_SESSION_PERIOD: 'benefit-programs-section.advanced.sessions.period',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_SESSION_ROLLOVER: 'benefit-programs-section.advanced.sessions.rollover',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_SESSION_RATE_LIMITED: 'benefit-programs-section.advanced.sessions.rate-limited',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDIT_PERIOD: 'benefit-programs-section.advanced.credits.period',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDIT_ROLLOVER: 'benefit-programs-section.advanced.credits.rollover',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDIT_RATE_LIMITED: 'benefit-programs-section.advanced.credits.rate-limited',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_CREDIT_PRICE: 'benefit-programs-section.advanced.credits.price',
  BENEFIT_PROGRAMS_SECTION_GROUP: 'benefit-programs-section.advanced.group',
  BENEFIT_PROGRAMS_SECTION_GROUP_VISIBILITY: 'benefit-programs-section.advanced.group-visibility',
  BENEFIT_PROGRAMS_SECTION_GROUP_CONTENT: 'benefit-programs-section.advanced.group-content',
  BENEFIT_PROGRAMS_TIME_MODAL: 'benefit-programs-section.time-modal',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_EDIT_BUTTON: 'benefit-programs.editable-text.edit-button',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_CONTENT: 'benefit-programs.editable-text.content',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_PLACEHOLDER: 'benefit-programs.editable-text.placeholder',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_INPUT: 'benefit-programs.editable-text.input',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_CONFIRM_BUTTON: 'benefit-programs.editable-text.confirm-button',
  BENEFIT_PROGRAMS_EDITABLE_TEXT_DECLINE_BUTTON: 'benefit-programs.editable-text.decline-button',
  BENEFIT_PROGRAMS_SECTION_ADVANCED_ROW_DESCRIPTION: 'benefit-programs-section.advanced.row-description'
};
//# sourceMappingURL=bm.js.map